import React,{Fragment, useState, useEffect} from 'react'
import { useLocation } from "react-router-dom";
import { MobileWarning } from './MobileWarning';
import {CETTabs} from "./CETTabs";

export const CETZone = () => {
  
  const [tabIndex, setTabIndex] = useState(0);
  let location = useLocation();
  
  useEffect(() => {
    if (location.state && location.state.tabId !== undefined) {
      setTabIndex(location.state.tabId);
    } else {
      // No state passed → fallback to path detection
      const path = location.pathname;
  
      if (path.includes("exam-dates")) setTabIndex(0);
      else if (path.includes("exam-notices")) setTabIndex(1);
      else setTabIndex(0);  // default tab
    }
  // if (location.state) {
  //   setTabIndex(location.state.tabId);
  //   }
  // else { 
  //   setTabIndex(0);
  // }
  //},[location.state])
},[location])
  
  return (
    <Fragment>
      <MobileWarning/>
      <div className="w-100vh h-auto">
           <CETTabs tabId={tabIndex} />
      </div>
    </Fragment>
  );
}

